import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, OnDestroy } from '@angular/core';
import { Contact } from '../../../../models';
import { CommonDataSharedService } from 'app/services';


@Component({
  selector: 'app-student-contact-card',
  templateUrl: './student-contact-card.component.html',
  styleUrls: ['./student-contact-card.component.scss']
})
export class StudentContactCardComponent implements OnChanges, OnDestroy {
  emailValid = true;
  mobileValid = true;
  @Input() contactInputData: any;
  @Output() contactUpdate = new EventEmitter<any>();
  contactModel = new Contact();
  formsTouched = false;

  constructor(
    private _commonDataSharedService: CommonDataSharedService
  ) {

  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['contactInputData'] !== undefined && changes['contactInputData'].currentValue !== undefined) {
      this.contactModel = changes['contactInputData'].currentValue;
    }
  }

  updateContact() {  
    if (!this.mobileValid || !this.emailValid) {
      this.formsTouched = true;
      this._commonDataSharedService.duplicateContact.next(false);
    } else {
      this._commonDataSharedService.duplicateContact.next(true);

    }

    this.contactUpdate.emit(this.contactModel);
  }

  getCurrentAddress() {
    return this.contactModel ? this.contactModel.address : {};
  }

  onAddressUpdated(event) {
    if (event) {
      this.contactModel.address = event;
      this.updateContact();
    }
  }

  getEmail() {
    return this.contactModel ? this.contactModel.communications : {};
  }

  onEmailUpdated(event) {
    if (event) {
      this.emailValid = event.valid;
      this.formsTouched = true;
      this.contactModel.communications.email = event.email;
      this.updateContact();
    }
  }

  getPhone() {
    return this.contactModel ? this.contactModel.communications : {};
  }

  onPhoneUpdated(event) {
    if (event) {
      this.mobileValid = event.valid;
      this.formsTouched = true;
      this.contactModel.communications.phone = event.phone;
      this.updateContact();
    }
  }

  getContactData(): Contact {
    return this.contactModel || new Contact();
  }

  ngOnDestroy() {
    this.formsTouched = false;
  }
}
